module.exports = __webpack_public_path__ + "static/media/203.a1ef90c3.jpg";